import { Container, Row, Col } from "react-bootstrap"

export const Footer = () => {
    const currentYear = new Date().getFullYear();
    
    return (

        <footer className="footer">
            <Container>
                <Row className="align-item-center">
                    <Col sm={12} className="text-center text-sm-center">
                        <p>© {currentYear} CopyRight.</p>
                        <p>Based in Barcelona</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}